import { render, staticRenderFns } from "./LogoBack.vue?vue&type=template&id=f6312c58&"
import script from "./LogoBack.vue?vue&type=script&lang=js&"
export * from "./LogoBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports